import { render, staticRenderFns } from "./LinkSuccess.vue?vue&type=template&id=119b6084&scoped=true"
import script from "./LinkSuccess.vue?vue&type=script&lang=js"
export * from "./LinkSuccess.vue?vue&type=script&lang=js"
import style0 from "./LinkSuccess.vue?vue&type=style&index=0&id=119b6084&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b6084",
  null
  
)

export default component.exports